module.exports = __webpack_public_path__ + "img/AL271-2-EN.bd0a2b32.jpg";